import { render, staticRenderFns } from "./HeadDiagram.vue?vue&type=template&id=6c509b3e&scoped=true"
import script from "./HeadDiagram.vue?vue&type=script&lang=js"
export * from "./HeadDiagram.vue?vue&type=script&lang=js"
import style0 from "./HeadDiagram.vue?vue&type=style&index=0&id=6c509b3e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c509b3e",
  null
  
)

export default component.exports